export default __webpack_public_path__ + "static/media/check-status.393166bd.svg";